<template>
  <div class="allocation-detail" data-testid="allocation-detail">
    <div class="allocations-chart">
      <BaseText
        v-if="updatedAt"
        class="allocations-chart__updated"
        size="xs"
        :color="NebraskaColors.elementSecondary"
      >
        Atualizado em {{ updatedAt }}
      </BaseText>
      <DonutChart
        data-testid="allocations-product-chart"
        :data="chartAllocations"
        :has-label="false"
        show-total-allocation
        :total-allocation="productAllocations.totalValue.formatted"
        show-zero-values
      />
    </div>
    <PortfolioProductsListWithDetails
      data-testid="allocations-product-list"
      :allocations="productAllocations.allocations"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { PortfolioProductsListWithDetails } from '../PortfolioProductsListWithDetails';
import { DonutChart } from '@/modules/common/components/charts/DonutChart';
import { parseAllocationsToChartData } from './helpers/helpers';
import { IProductAllocationsResponse } from '@/modules/wealth/services/investment';

@Component({
  components: { BaseText, PortfolioProductsListWithDetails, DonutChart }
})
export default class AllocationDetail extends Vue {
  readonly NebraskaColors = NebraskaColors;

  @Prop({ type: Object, required: true })
  readonly productAllocations!: IProductAllocationsResponse;

  get chartAllocations() {
    return parseAllocationsToChartData(this.productAllocations.allocations);
  }

  get updatedAt() {
    return this.productAllocations.lastUpdateAt;
  }
}
</script>

<style lang="less" scoped>
.allocations-chart {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: @size-spacing-x500 @size-spacing-x350;
  &__updated {
    margin-bottom: @size-spacing-x500;
  }
}
</style>
